import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig } from "../../../../../store/slices/Admin/Store/storeSlice";
import dayjs from "dayjs";

const useCurbSide = (formik) => {
  const dispatch = useDispatch();
  const { isEdit, curbTimeError, isImageUploading } = useSelector(
    (state) => state.store,
  );

  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
        state.isEdit = false;
      }),
    );
  };

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const getTimeValue = (day, type) => {
    const value = formik?.values?.curbside_hours?.[day]?.[type];
    return value ? dayjs(value, "h:mm A") : null;
  };

  const getStatus = (day) => {
    const dayData = formik?.values?.curbside_hours?.[day];
    if (dayData) {
      return dayData.status || 1;
    }
    return 2;
  };

  const handleTimeChange = (day, type, newValue) => {
    const existingDay = formik?.values?.curbside_hours?.[day] || {};
    const updatedCurbsideHours = {
      ...formik?.values.curbside_hours,
      [day]: {
        ...existingDay,
        [type]: newValue ? newValue.format("h:mm A") : null,
      },
    };
    formik.setFieldValue("curbside_hours", updatedCurbsideHours);
  };

  const handleToggle = (day, checked) => {
    const newStatus = checked ? 1 : 2;
    const existingDay = formik?.values?.curbside_hours?.[day] || {};
    const updatedCurbsideHours = {
      ...formik?.values.curbside_hours,
      [day]: {
        ...existingDay,
        status: newStatus,
      },
    };
    formik.setFieldValue("curbside_hours", updatedCurbsideHours);
  };

  const getMinToTime = (day) => {
    const fromTime = getTimeValue(day, "from");
    if (fromTime) {
      return fromTime.add(1, "hour");
    }
    return null;
  };

  const handleNext = () => {
    dispatch(
      updateConfig((state) => {
        state.activeTab = "Office Delivery Hours";
      }),
    );
  };
  return {
    isEdit,
    daysOfWeek,
    curbTimeError,
    isImageUploading,
    handleCloseModal,
    handleTimeChange,
    handleToggle,
    getTimeValue,
    getStatus,
    getMinToTime,
    handleNext,
  };
};
export default useCurbSide;
